export default "__VITE_ASSET__483bdd9a__"